export const getIsSignatureResponse = (response) => response.type === 'SIGNATURE';

export const mapSubmissionResponses = (responses) => {
  const signatureResponse = responses.find((response) => getIsSignatureResponse(response));

  if (!signatureResponse) {
    return responses;
  }

  return responses
    .filter((response) => !getIsSignatureResponse(response))
    .map((response) =>
      response.question === 'Terms and Conditions'
        ? {
            ...response,
            fileUrl: signatureResponse?.fileUrl,
            isTermsAndConditionsSignature: true
          }
        : response
    );
};



// WEBPACK FOOTER //
// ./src/utils/mapSubmissionResponses.js